var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowToolbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 12,
    viewBox: "0 0 48 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FF5B5A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 24,
    cy: 6,
    r: 6,
    fill: "#FFBA44"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 42,
    cy: 6,
    r: 6,
    fill: "#12C84F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowToolbar);
export default __webpack_public_path__ + "static/media/window-toolbar.41a7dd064548c04fec055ac7e19771d3.svg";
export { ForwardRef as ReactComponent };